<date-picker-pds3
    [label]="'FiltersSidebar.Labels.DueOn' | translate"
    [date]="model().date"
    [inputPlaceholder]="currentLanguage === 'fr-CA' ? 'AAAA-MM-JJ' : 'YYYY-MM-DD'"
    [formatDateFn]="WkDateFormat.formatDateFn"
    [parseDateFn]="WkDateFormat.parseDateFn"
    [validateDateStringFn]="WkDateFormat.validateDateStringFn"
    mask="9999-99-99"
    flowClass="date-picker-input"
    [i18n]="WkDateFormat.getDatePickerI18n(currentLanguage)"
    (dateChange)="dateChange.emit($any($event))"
    inputTitle=""
/>
